import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const Batteries = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Batteries"
    videos={[
      "https://www.youtube.com/embed/1tvvSUySfls",
      "https://www.youtube.com/embed/YFd0kb9Nwt0"
    ]}
    takeaways={[
      { text: "Numericals related to nernst equation." },
      { text: "Charging and Discharging of Li-Ion Battery." }
    ]}
    questions={[
      "Describe the intercalation mechanism of the battery used in a laptop during the charging and discharging processes. Explain the benefits and drawbacks of the battery.",
      "A cell using copper, cadmium electrodes, copper sulphate and cadmium sulphate solutions is constructed. The cell EMF is determined to be 0.79V. Concentration of copper sulphate solution is 0.5M. Determine the concentration of cadmium sulphate solution used. Standard reduction potentials values of copper and cadmium are 0.34V and –0.4V respectively."
    ]}
    exampleVideos={[]}
  />
);
}

export default Batteries;
